import { createContext, useState, Dispatch, SetStateAction } from 'react';

type IBuyBarSize = 'default' | 'large';

// If you ever decide to export buyBarSize and setBuyBarSize, then add this to interface:
// buyBarSize: IBuyBarSize;
// setBuyBarSize: Dispatch<SetStateAction<IBuyBarSize>>;
interface IBigBuyBarDesktopViewState {
  isBuyBarExpanded: boolean;
  setIsBuyBarExpanded: Dispatch<SetStateAction<boolean>>;
  isBuyBarSizeLarge: boolean;
  setBuyBarSizeLarge: (boolean) => void;
}

export const BigBuyBarDesktopViewStateContext = createContext<IBigBuyBarDesktopViewState>(null);

export const BigBuyBarDesktopViewStateProvider = ({ children }) => {
  // There are 2 states to the BigBuyBar, collapsed/closed and expanded/opened.
  // There is a third state, but will talk about that later.
  // 1. Collapsed: is when the BigBuyBar is minimized and user can only see the product sizes and prices.
  // 2. Expanded: is when the BigBuyBar is opened and user can see the different variants like Buy New, Buy Used, etc.
  //    Expanded BuyBar has two size variations, default and large:
  //    a. Default: is the default height size of the expanded BuyBar.
  //    b. Large: the height is taller compared to default height, about ~200px taller.
  //       The large BuyBar scenario happens when a grid inside the BigBuyBar has 2 or more rows.
  //       For example the grids for 'Buy Used' tab, special variant (Custom, Vintage, NikeID, etc), New with Defects, etc
  // We want to avoid doing three state because it will become cumbersome to always have to determined when it should expand to default vs large size.

  // isExpanded defines if the BuyBar is opened or not. Period.
  const [isBuyBarExpanded, setIsBuyBarExpanded] = useState(false);

  // buyBarSize defines the BigBuyBar size: default or large
  const [buyBarSize, setBuyBarSize] = useState<IBuyBarSize>('default');

  // GET and SET helpers based on boolean
  const isBuyBarSizeLarge = buyBarSize === 'large';
  const setBuyBarSizeLarge = (makeLarge?: boolean) => {
    const size = makeLarge ? 'large' : 'default';
    setBuyBarSize(size);
  };

  // If needed, include `buyBarSize` and `setBuyBarSize` for more customization options
  // For now is not a requirement, so no need for further complexity
  const providerValue = {
    isBuyBarExpanded,
    setIsBuyBarExpanded,
    isBuyBarSizeLarge,
    setBuyBarSizeLarge,
  };

  return (
    <BigBuyBarDesktopViewStateContext.Provider value={providerValue}>
      {children}
    </BigBuyBarDesktopViewStateContext.Provider>
  );
};
